<app-user-header></app-user-header>
<div class="col-12 text-center webview">
    <!-- <img src="assets/images/eva-icons.svg" class="signimg" width="100" /> -->
</div>
<div class="text-center">
    <h2 class="usersethead semi-bold pl-5 pr-5">Hello, {{name | titlecase}}</h2>
    <h6 class="usersetsubhead font-weight-normal-calibre text-muted pb-3">Honest Gorilla member since {{createdDate | date : 'MMMM yyyy'}}</h6>
    <hr class="hrbdr"/> 
</div>
<app-notification-details></app-notification-details>
<app-plan-history></app-plan-history>
<app-hg-blogs></app-hg-blogs>
<div class="energybillssect">
</div>
<app-useraccount-settings></app-useraccount-settings>
<app-user-footer></app-user-footer>
<div class="container-fluid"></div>